import { FC, SVGProps } from 'react'

export const Mirror: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 6C3 3.23858 5.23858 1 8 1C10.7614 1 13 3.23858 13 6V15H3V6Z" fill="currentColor" />
  </svg>
)
